export const dayTitleStyle = {
    fontSize: '32px',
    // marginBottom: '10px',
    color: '#333',
    fontWeight: "bold",
    fontFamily: 'Jost-Regular',
};
export const dayItemsStyle = {paddingLeft: '0', margin: '0', listStyleType: 'none'};

export const dayItemsLiStyle = {
    marginBottom: '5px',
    fontFamily: 'Jost-Regular',
    color: '#555'
};
export const dayItemTextStyle = {
    fontSize: '22px',
    fontFamily: 'Jost-Regular',
};
export const dividerStyle = {
    borderColor: '#29362C',
    borderBottomWidth: '4px',
    marginTop: '9px',
    marginBottom: '9px',
    width: '80%',
    marginLeft: '10%',
};
